import { COOKIE_CONSENT_OPTIONS } from '../../constants';
import { component } from '../../framework/component.decorator';
import { events } from '../../events';
import { menu } from '../../menu';
import { CookieConsentType } from '../../models/cookie-consent-type.enum';
import { button } from '../../templating/button.element';
import { emojiIcon } from '../../templating/emoji-icon.element';
import { Icons } from '../../templating/icon.element';
import { CookieConsentOption } from '../../types/cookie-consent-option.type';
import { MenuOption } from '../../types/menu-option.type';
import { BaseComponent } from '../../framework/base.component';
import styles from './consent.component.scss';
import { OnDestroy } from '../../framework/on-destroy.interface';
import { OnInit } from '../../framework/on-init.interface';
import { store } from '../../store';

@component({
  selector: 'app-consent',
  styles,
})
export class ConsentComponent
  extends BaseComponent<ConsentComponent>
  implements OnDestroy, OnInit
{
  constructor() {
    super(ConsentComponent);
  }

  async createInitialComponent() {
    return [
      button(
        {
          onCreate: (element) => {
            element.title = 'Cookie consent';
            element.addEventListener('click', () => this.openRootMenu(false));
          },
        },
        [emojiIcon('🍪')]
      ),
    ];
  }

  async onInit() {
    if (this.userShouldSeeConsent()) {
      this.openRootMenu(true);
    }

    store.set('lastTimeUserWasPresentedForConsent', new Date().getTime());
  }

  onDestroy(): void {}

  private async openRootMenu(backgroundIsNotDismissable: boolean) {
    menu<CookieConsentOption>(
      () => {
        const consent = store.get('consent') ?? [];

        return [
          {
            meta: true,
            text: 'Choose which 🍪 cookie types you would like to accept',
          } as MenuOption<any>,
          {
            value: CookieConsentType.StrictlyNecessary,
            text: 'Strictly necessary',
            selected: true,
            overrideNonDismissRestriction: true,
          },
          ...COOKIE_CONSENT_OPTIONS.map((option) => ({
            ...option,
            selected: consent?.find((c) => c === option.value) !== undefined,
            icon:
              consent?.find((c) => c === option.value) !== undefined
                ? ('check' as Icons)
                : undefined,
            callback: async () => await this.onOptionCallback(option),
          })),
          {
            text: 'Close',
            selected: false,
            icon: 'x',
            overrideNonDismissRestriction: true,
          } as MenuOption<any>,
        ];
      },
      {
        shouldNotDismissOnSelection: true,
      }
    );
  }

  private async onOptionCallback(option: CookieConsentOption) {
    const changeInStorage = events.onceAsync('consent-set');

    events.emit('toggle-consent', { consent: option.value });

    await changeInStorage;
  }

  private userShouldSeeConsent() {
    const consent = store.get('consent') ?? [];
    const now = new Date().getTime();
    const twentyFourHoursInMillis = 24 * 3600 * 1000;
    const lastTimeUserWasPresentedForConsent =
      store.get('lastTimeUserWasPresentedForConsent') ??
      now - twentyFourHoursInMillis - 1;

    if (consent.length > 0) {
      return false;
    }

    const diff = now - lastTimeUserWasPresentedForConsent;

    // Show at least once every day if no consent was given
    return diff > twentyFourHoursInMillis;
  }
}
